import * as userRequest from "@/utils/userRequest";

interface QueryParams {
    startTime?: string;
    endTime?: string;
    filter: string;
}

export default async function getReferralService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any,
    queryParams?: QueryParams
) {
    try {
        const res = await userRequest.get("affiliates/referral-data", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                filter: queryParams?.filter,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
        });
        console.log("🚀 ~ getReferralService ~ res:", res);
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getReferralService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
